exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3wZko{height:275px;overflow:hidden}._3TnvW{overflow-x:auto;overflow-y:hidden;margin:16px 8px;margin:1rem .5rem;-webkit-overflow-scrolling:touch}._22C5Y{padding:0 16px;padding:0 1rem;margin-top:32px;margin-top:2rem}._23Sl1{width:64px;width:4rem;height:240px;background:linear-gradient(90deg,rgba(43,45,52,0) 22%,rgba(43,45,52,.83));position:absolute;z-index:1;right:0;pointer-events:none}::-webkit-scrollbar{display:none}ul{margin:0;padding-left:0}.MTcLN{display:flex}", ""]);

// exports
exports.locals = {
	"cardScroll__wrapper": "_3wZko",
	"main_container": "_3TnvW",
	"title_container": "_22C5Y",
	"shadow": "_23Sl1",
	"main__container_wraper": "MTcLN"
};